module.exports = import('./openhps-rdf.es.js');